export enum Role {
  ProviderSignIn = 'ProviderSignIn',
  DomainAdmin = 'DomainAdmin',
  UserAccountAdministrator = 'UserAccountAdministrator',
  SingleUser = 'SingleUser',
  DomainUser = 'DomainUser',
  EmergencySignIn = 'EmergencySignIn',
  SystemAdmin = 'SystemAdmin',
  LimitedAdmin = 'LimitedAdmin' // it isn't hasLimitedAdminRole()
}

export enum ProviderRole {
  CompanyAdministrator = 'CompanyAdministrator',
  UserAccountAdministrator = 'UserAccountAdministrator',
  Other = 'UserAccountAdministrator'
}

const ADMIN_ROLES = [Role.DomainAdmin, Role.UserAccountAdministrator];

export function hasDomainAdminRole(roles: Role[]): boolean {
  return roles.includes(Role.DomainAdmin); // sign in with GAA permission
}

export function hasLimitedAdminRole(roles: Role[], providerRoles: ProviderRole[]): boolean {
  return roles.includes(Role.UserAccountAdministrator) && providerRoles.includes(ProviderRole.CompanyAdministrator); // sign in without GAA permission
}

export function hasAdminRole(roles: Role[]): boolean {
  return roles.some((role) => ADMIN_ROLES.includes(role));
}

export function hasEmergencySignInRole(roles: Role[]): boolean {
  return roles.includes(Role.EmergencySignIn);
}

export function hasUserAccountAdminRole(roles: Role[]): boolean {
  return roles.includes(Role.UserAccountAdministrator);
}

// TODO: need check different between `hasUserAccountAdminRole` and current method with `!CompanyAdministrator` in components conditions
// export function isUserAccountAdmin(roles: Roles[], providerRoles: ProviderRole[]): boolean {
//   return roles.includes(Roles.UserAccountAdministrator) && !providerRoles.includes(ProviderRole.CompanyAdministrator);
// }

export function hasDomainUserRole(roles: Role[]): boolean {
  return roles.includes(Role.DomainUser);
}

export function hasSingleUserRole(roles: Role[]): boolean {
  return roles.includes(Role.SingleUser);
}

export function hasProviderRole(roles: Role[]): boolean {
  return roles.includes(Role.ProviderSignIn);
}
